import React from 'react';
import { PortfolioFooterContent } from '../../types/portfolio';
import './Footer.css';

// Importing a selection of images from the homePage asset folder
import img1 from '../../asset/homePage/1.jpg';
import img2 from '../../asset/homePage/2.jpg';
import img4 from '../../asset/homePage/4.jpg';
import imgP4 from '../../asset/homePage/4.jpg';
import imgMain from '../../asset/homePage/MAIN.jpg';
import imgMains from '../../asset/homePage/MAINs.jpg';
import imgSketch1 from '../../asset/homePage/sketch1629039853031.jpg';
import imgSketch2 from '../../asset/homePage/sketch1643641203920.jpg';
import imgDevice from '../../asset/homePage/裝置.jpg';
import imgAsset3 from '../../asset/homePage/資產 3.jpg';

const images = [
  img1,
  img2,
  img4,
  imgP4,
  imgMain,
  imgMains,
  imgSketch1,
  imgSketch2,
  imgDevice,
  imgAsset3,
];

// Duplicate images for a seamless loop
const row1Images = [...images, ...images];
const row2Images = [...images.slice(5), ...images.slice(0, 5), ...images.slice(5), ...images.slice(0, 5)];

type FooterProps = {
  content: PortfolioFooterContent;
};

const Footer: React.FC<FooterProps> = ({ content }) => {

  return (
    <footer className="animated-footer">
      <div className="image-scroller-container">
        <div className="scrolling-row-wrapper">
            <div className="scrolling-row left">
            {row1Images.map((src, index) => (
                <img key={`row1-${index}`} src={src} alt="" className="scrolling-image" />
            ))}
            </div>
        </div>
        <div className="scrolling-row-wrapper">
            <div className="scrolling-row right">
            {row2Images.map((src, index) => (
                <img key={`row2-${index}`} src={src} alt="" className="scrolling-image" />
            ))}
            </div>
        </div>
      </div>
      <div className="footer-color-overlay"></div>
      <div className="footer-text-content">
        <div className="footer-content">
          <h2>{content.title}</h2>
          <p>{content.message}</p>
          <a href={`mailto:${content.email}`} className="footer-email-link">{content.email}</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;